import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobPaymentRequestActions'
import * as api from '../../api/job/paymentRequests'

function* jobPaymentRequestsRefresh(action) {
  try {
    let payload = []
    if (action.fromDashboard) {
      payload = yield call(api.getPaymentRequestsDashboard, action.assignedToId)
    } else {
      payload = yield call(api.getPaymentRequests, action.jobId)
    }
    yield put({ type: constants.JOB_PAYMENT_REQUESTS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_PAYMENT_REQUESTS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobPaymentRequests() {
  yield takeLatest(constants.JOB_PAYMENT_REQUESTS_REFRESH.ACTION, jobPaymentRequestsRefresh)
}

function* getPaymentRequestByVendorId(action) {
  try {
    const payload = yield call(api.getPaymentRequestsByVendorId, action.vendorId)
    yield put({ type: constants.GET_PAYMENT_REQUEST_BY_VENDOR_ID.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PAYMENT_REQUEST_BY_VENDOR_ID.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetPaymentRequestsByVendorId() {
  yield takeLatest(constants.GET_PAYMENT_REQUEST_BY_VENDOR_ID.ACTION, getPaymentRequestByVendorId)
}

function* sagaCreateJobPaymentRequest(action) {
  try {
    const payload = {
      created_by_id: action.created_by_id,
      updated_by_id: action.updated_by_id,
      job_id: action.job_id,
      due_date: action.due_date,
      payment_type: action.payment_type,
      payable_from: action.payable_from,
      payable_to_id: action.payable_to_id,
      description: action.description,
      amount: action.amount
    }

    yield call(api.createPaymentRequest, payload)
    yield put({ type: constants.JOB_PAYMENT_REQUEST_CREATE.SUCCESS, payload })
    yield call(jobPaymentRequestsRefresh, { jobId: action.job_id })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_PAYMENT_REQUEST_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobPaymentRequest() {
  yield takeLatest(constants.JOB_PAYMENT_REQUEST_CREATE.ACTION, sagaCreateJobPaymentRequest)
}

function* sagaUpdateJobPaymentRequest(action) {
  try {
    const payload = {
      job_id: action.jobId,
      payment_request_id: action.paymentRequestId,
      content: action.content,
      updated_by_id: action.userId,
      created_by_id: action.userId,
      created_by_id_payment_request: action.created_by_id_payment_request,
      user_id: 1
    }
    yield call(api.updatePaymentRequest, payload)
    yield put({ type: constants.JOB_PAYMENT_REQUEST_UPDATE.SUCCESS, payload })
    yield call(jobPaymentRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_PAYMENT_REQUEST_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobPaymentRequest() {
  yield takeLatest(constants.JOB_PAYMENT_REQUEST_UPDATE.ACTION, sagaUpdateJobPaymentRequest)
}

function* sagaDeleteJobPaymentRequest(action) {
  try {
    const payload = {
      payment_request_id: action.paymentRequestId
    }
    yield call(api.deletePaymentRequest, payload)
    yield put({ type: constants.JOB_PAYMENT_REQUEST_DELETE.SUCCESS, payload })
    yield call(jobPaymentRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_PAYMENT_REQUEST_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobPaymentRequest() {
  yield takeLatest(constants.JOB_PAYMENT_REQUEST_DELETE.ACTION, sagaDeleteJobPaymentRequest)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      paymentRequestId: action.paymentRequestId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_PAYMENT_REQUESTS_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { paymentRequestId: action.paymentRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_PAYMENT_REQUESTS_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_PAYMENT_REQUESTS_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.paymentRequestId)
    yield put({ type: constants.GET_PAYMENT_REQUESTS_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PAYMENT_REQUESTS_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_PAYMENT_REQUESTS_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_PAYMENT_REQUESTS_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { paymentRequestId: action.paymentRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_PAYMENT_REQUESTS_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_PAYMENT_REQUESTS_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      paymentRequestId: action.paymentRequestId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_PAYMENT_REQUESTS_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { paymentRequestId: action.paymentRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_PAYMENT_REQUESTS_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_PAYMENT_REQUESTS_ATTACHMENT.ACTION, deleteAttachment)
}

// notes
function* fetchPaymentRequestNote(action) {
  try {
    const paymentRequestNotes = yield call(api.fetchPaymentRequestNote, {
      paymentRequestId: action.paymentRequestId
    })
    yield put({ type: constants.GET_PAYMENT_REQUEST_NOTE.SUCCESS, paymentRequestNotes })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PAYMENT_REQUEST_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchPaymentRequestNote() {
  yield takeLatest(constants.GET_PAYMENT_REQUEST_NOTE.ACTION, fetchPaymentRequestNote)
}

function* createPaymentRequestNote(action) {
  try {
    const payload = {
      content: action.content,
      paymentRequestId: action.paymentRequestId
    }
    yield call(api.createPaymentRequestNote, payload)
    yield put({ type: constants.CREATE_PAYMENT_REQUEST_NOTE.SUCCESS, payload })
    yield call(fetchPaymentRequestNote, { paymentRequestId: action.paymentRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_PAYMENT_REQUEST_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreatePaymentRequestNote() {
  yield takeLatest(constants.CREATE_PAYMENT_REQUEST_NOTE.ACTION, createPaymentRequestNote)
}

function* editPaymentRequestNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editPaymentRequestNote, payload)
    yield put({ type: constants.EDIT_PAYMENT_REQUEST_NOTE.SUCCESS, payload })
    yield call(fetchPaymentRequestNote, { paymentRequestId: action.paymentRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_PAYMENT_REQUEST_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditPaymentRequestNote() {
  yield takeLatest(constants.EDIT_PAYMENT_REQUEST_NOTE.ACTION, editPaymentRequestNote)
}

function* deletePaymentRequestNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deletePaymentRequestNote, payload)
    yield put({ type: constants.DELETE_PAYMENT_REQUEST_NOTE.SUCCESS, payload })
    yield call(fetchPaymentRequestNote, { paymentRequestId: action.paymentRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_PAYMENT_REQUEST_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeletePaymentRequestNote() {
  yield takeLatest(constants.DELETE_PAYMENT_REQUEST_NOTE.ACTION, deletePaymentRequestNote)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobPaymentRequests),

    fork(watchCreateJobPaymentRequest),
    fork(watchUpdateJobPaymentRequest),
    fork(watchDeleteJobPaymentRequest),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments),

    fork(watchGetPaymentRequestsByVendorId),

    //notes
    fork(watchFetchPaymentRequestNote),
    fork(watchCreatePaymentRequestNote),
    fork(watchEditPaymentRequestNote),
    fork(watchDeletePaymentRequestNote)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobPaymentRequestSaga.js